import { get } from 'lodash';
import getClientInstance from '../../../app/config/apollo-client';
import SERIVCE_SPECIALTIES_QUERY from './queries/fetch-specialties-for-initiate-referral-query.js';

const fetchSpecialtiesForInitiateReferral = (memberId, stateCode)  => {
  const apolloClient = getClientInstance();

    const promise = 
      apolloClient.query({
        variables: {
          stateCode,
          memberId: memberId
        },
        query: SERIVCE_SPECIALTIES_QUERY
      })
      .then(response => {
        const serviceSpecialties = get(response, 'data.member.serviceSpecialtiesForCareHub');

        return serviceSpecialties;
      })

  return promise;
}

export default fetchSpecialtiesForInitiateReferral;
